import type { ApiErrorBody } from '../types/api';

export class ApiError extends Error {
  readonly status: number;
  readonly code?: string;
  readonly errors?: Record<string, string[]>;

  constructor(status: number, body: ApiErrorBody) {
    super(body.message || 'Bir hata oluştu.');
    this.name = 'ApiError';
    this.status = status;
    this.code = body.code;
    this.errors = body.errors;
  }
}

export class ApiAuthError extends ApiError {
  constructor(body: ApiErrorBody) {
    super(401, body);
    this.name = 'ApiAuthError';
  }
}

export class ApiForbiddenError extends ApiError {
  constructor(body: ApiErrorBody) {
    super(403, body);
    this.name = 'ApiForbiddenError';
  }
}

export function getErrorMessage(error: unknown, fallback = 'Bir hata oluştu.'): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error) return error.message;
  return fallback;
}

export function isApiAuthError(error: unknown): error is ApiAuthError {
  return error instanceof ApiAuthError;
}

export function isApiForbiddenError(error: unknown): error is ApiForbiddenError {
  return error instanceof ApiForbiddenError;
}
